import * as React from "react"
import { Command } from "cmdk"
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./components/ui/command"
import { useDispatch } from "react-redux"
import { resetPendingChanges } from "./store/flowSlice"
import { useSelector } from "react-redux"
import { RootState } from "./store/store"
import { ExportJobService } from "./services/job/ExportJobService"

export function DebugCommandView() {
  const [open, setOpen] = React.useState(false)
  const dispatch = useDispatch()

  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setOpen((open) => !open)
      }
    }
    document.addEventListener("keydown", down)
    return () => document.removeEventListener("keydown", down)
  }, [])
  
  const {hoveredJob} = useSelector((state: RootState) => state.debug)
  const handleResetExportProgressOfHovered = async () => {
    if(hoveredJob){
      ExportJobService.getInstance().resetExportProgress(hoveredJob.enrichmentJobId, hoveredJob.enrichmentDbId)
    }
  }

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Type a command or search..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => {
            dispatch(resetPendingChanges())
            setOpen(false)
          }}>
            <span>Reset Pending Changes</span>
          </CommandItem>
          <CommandItem onSelect={() => {
            handleResetExportProgressOfHovered()
            setOpen(false)
          }}>
            <span>Reset Export Progress of Hovered Job</span>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  )
}